import { Error, Loader } from './common'
import { changeBreakpoint } from '../actions/app'
import { fetchUserDetails } from '../actions/user'
import {
  fetchEducationPeriods,
  fetchAllowedSSDMaterials,
  fetchExamWindows,
} from '../actions/settings'
import { AppRoutes } from '../containers'

import '../assets/style/css/global.css'
import '../assets/style/css/apricot.css'

const mapStateToProps = state => {
  return {
    educationPeriodCd: state.settingsEducationPeriod?.current,
    loading: !state.user.fetched || !state.settingsEducationPeriod.fetched,
    error: state.user.error || state.settingsEducationPeriod.error,
  }
}

const App = ({
  educationPeriodCd,
  loading,
  error,
  changeBreakpoint,
  fetchEducationPeriods,
  fetchUserDetails,
  fetchAllowedSSDMaterials,
  fetchExamWindows,
}) => {
  useEffect(() => {
    fetchUserDetails()
    fetchEducationPeriods()
    fetchAllowedSSDMaterials()
  }, [])

  useEffect(() => {
    APRICOT.CBUtils.breakpoints(true)
    changeBreakpoint(APRICOT.CBUtils.viewport())
    $(document).on('breakpoint_change', (e, data) => changeBreakpoint(data))

    return () => $(document).off('breakpoint_change')
  }, [])

  useEffect(() => {
    if (educationPeriodCd) {
      fetchExamWindows({ educationPeriodCd })
    }
  }, [educationPeriodCd])

  if (error) {
    return (
      <div className="container" style={{ marginTop: 20 }}>
        <Error
          title="Error Retrieving Data"
          message={error || 'An error occurred. Please try again later.'}
        />
      </div>
    )
  }

  if (loading) {
    return <Loader />
  }

  return <AppRoutes />
}

export default connect(mapStateToProps, {
  changeBreakpoint,
  fetchUserDetails,
  fetchEducationPeriods,
  fetchExamWindows,
  fetchAllowedSSDMaterials,
})(App)
